import useUrlParams from '../../hooks/useUrlParams';
import './CommandCenter.scss'
import Hud from './hud/Hud';
import Planning from './planning/Planning';
import Files from './Files/Files';
import Reports from '../../../validate/details/Reports';
import useScenario from '../../hooks/useScenario';
import { SCENARIO_DEPLOYMENT_TYPES } from '../../../simulate/constants';
import TelemetryDashboard from './telemetry/telemetry-dashboard';
import useTelemetry from './telemetry/hooks/useTelemetry';
import Monitor from './monitor/Monitor';
import { TelemetryNotFound } from './telemetry/components';


const CommandCenter = () => {
  const {
    tab_name,
    dashboard
  } = useUrlParams()

  const { scenario } = useScenario()
  const { scenarioDeploymentDetails } = useTelemetry()

  const deploymentType = (scenario?.scenarioDeploymentType ?? '').toUpperCase()
  const isValidateScenario = deploymentType === SCENARIO_DEPLOYMENT_TYPES.VALIDATE
  const isValidateSummary = deploymentType === SCENARIO_DEPLOYMENT_TYPES.VALIDATE && dashboard === 'summary'
  const isHudTab = tab_name === 'hud'
  const isPlanTab = Boolean(tab_name?.includes('plan'))
  const isFilesTab = Boolean(tab_name?.includes('files'))
  const isMonitorTab = tab_name === 'monitor'
  const isReportsTab = isValidateScenario && tab_name === 'reports'
  const showTelemetry = isMonitorTab && scenarioDeploymentDetails?.dashboardVersion === '2.0.0'
  const showGrafana = isMonitorTab && scenarioDeploymentDetails?.dashboardVersion === '1.0.0'
  const telemetryDashboardNotFound = isMonitorTab && !showTelemetry && !showGrafana

  return (
    <div className='command__center_container'>
      {isHudTab && !isValidateSummary && <Hud />}
      {isPlanTab && <Planning />}
      {isFilesTab && <Files />}
      {showTelemetry && <TelemetryDashboard />}
      {telemetryDashboardNotFound && <TelemetryNotFound />}
      {showGrafana && <Monitor />}
      {isReportsTab && <Reports />}
    </div>
  )
}

export default CommandCenter
